import { Button, Modal } from "antd";
import classes from "./TermsAndConditions.module.scss";

export default function TermsAndConditions({ open, onCancel }) {
  return (
    <Modal
      title="Terms and Conditions"
      open={open}
      onCancel={onCancel}
      className={classes.modal}
      width={"40vw"}
      styles={{
        body: { height: "50vh", padding: "0 12px 12px" },
      }}
      footer={[
        <Button key="ok" type="primary" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      {TERMS_EN}
      <br />
      <br />
      <hr />
      <br />
      <br />
      {TERMS_AZ}
    </Modal>
  );
}

const TERMS_EN = (
  <>
    <h3>1. Introduction</h3>
    <p>
      These Terms and Conditions (hereinafter referred to as "Terms") govern the
      registration and use of the Master Delivery Schedule (MDS) system by
      suppliers and vendors (hereinafter referred to as "Supplier" or "Vendor").
      By registering for or using the MDS system, you agree to these Terms in
      full. If you do not agree with these Terms, you are not authorized to use
      the System.
    </p>

    <h3>2. Definitions</h3>
    <p>
      <strong>MDS System:</strong> The Master Delivery Schedule system used to
      manage and streamline delivery schedules.
    </p>
    <p>
      <strong>Supplier/Vendor:</strong> Any entity or individual providing
      goods, materials, or services and registering to use the MDS system.
    </p>

    <h3>3. Registration Process</h3>
    <h4>
      <span>3.1</span> Eligibility
    </h4>
    <p>
      Suppliers must meet all pre-defined eligibility criteria set by the
      Administrator to register for and use the MDS system. Failure to meet
      eligibility requirements may result in denial of access to the System.
    </p>

    <h4>
      <span>3.2</span> Accurate Information
    </h4>
    <p>
      During registration, Suppliers must provide accurate and up-to-date
      information, including company details, contact information, drivers (and
      occupants if applicable), and relevant delivery capabilities. In this
      matter, the consent of the drivers or occupants must be obtained
      beforehand. Suppliers are responsible for updating this information as
      necessary.
    </p>

    <h4>
      <span>3.3</span> Approval of Registration
    </h4>
    <p>
      Registration applications will be approved by the system. If information
      is incorrect or incomplete, the system will deny a request.
    </p>

    <h3>4. Supplier Responsibilities</h3>
    <h4>
      <span>4.1</span> Compliance with Delivery Schedules
    </h4>
    <p>
      Suppliers agree to adhere to all delivery schedules, timelines, and
      quantities as specified in the MDS system.
    </p>

    <h4>
      <span>4.2</span> Use of the System
    </h4>
    <p>
      Suppliers agree to use the MDS system solely for managing and coordinating
      deliveries as part of contractual obligations. Misuse of the System or
      entry of false data is strictly prohibited.
    </p>

    <h4>
      <span>4.3</span> Data Accuracy
    </h4>
    <p>
      Suppliers are responsible for ensuring that all data entered the MDS
      system, including delivery times, locations, and driver/car details, is
      accurate and up to date.
    </p>

    <h4>
      <span>4.4</span> Confidentiality
    </h4>
    <p>
      Suppliers must maintain the confidentiality of any sensitive information
      accessed through the MDS system. Sharing confidential information with
      unauthorized third parties is strictly prohibited.
    </p>

    <h3>5. Delivery and Performance Standards</h3>
    <h4>
      <span>5.1</span> Adherence to Agreed Terms
    </h4>
    <p>
      Suppliers must ensure that all deliveries meet the specifications,
      timelines, and standards agreed upon in their contracts. Any delays or
      deviations must be communicated to FA’s representative as early as
      possible through the MDS system.
    </p>

    <h4>
      <span>5.2</span> Force Majeure
    </h4>
    <p>
      In the event of unforeseeable circumstances beyond the Supplier’s control,
      such as natural disasters or strikes, that prevent adherence to delivery
      schedules, Suppliers must notify the MDS team immediately via e-mail
      <a href="mailto:mds@cop29.az">mds@cop29.az</a> or contact
      <a href="tel:+994 10 252 44 80">+994 10 252 44 80</a> to agree on new
      delivery terms.
    </p>

    <h3>6. Use of System and Security</h3>
    <h4>
      <span>6.1</span> Login Credentials
    </h4>
    <p>
      Suppliers are responsible for maintaining the confidentiality of their
      login credentials. Any unauthorized access or use of the system must be
      reported immediately to the MDS team.
    </p>

    <h4>
      <span>6.2</span> System Integrity
    </h4>
    <p>
      Suppliers must not engage in any activities that could compromise the
      security, integrity, or performance of the MDS system, including but not
      limited to hacking, tampering, or introducing malware.
    </p>

    <h3>7. Data Protection and Privacy</h3>
    <h4>
      <span>7.1</span> Collection of Data
    </h4>
    <p>
      By using the MDS system, Suppliers agree that the Administrator may
      collect, store, and use data related to deliveries, performance metrics,
      and Supplier activities for the purpose of improving system operations.
    </p>

    <h4>
      <span>7.2</span> Protection of Supplier Data
    </h4>
    <p>
      The MDS team will implement appropriate technical and organizational
      measures to protect Supplier data. However, Suppliers are responsible for
      implementing their own measures to protect their systems from unauthorized
      access.
    </p>

    <h3>8. Termination and Suspension</h3>
    <h4>
      <span>8.1</span> Termination by Supplier
    </h4>
    <p>
      Suppliers may terminate their registration and stop using the MDS system
      at any time, provided they fulfill all outstanding delivery obligations.
    </p>

    <h4>
      <span>8.2</span> Termination by Administrator
    </h4>
    <p>
      The Administrator reserves the right to suspend or terminate a Supplier’s
      access to the MDS system at any time, with or without notice, for reasons
      including but not limited to non-compliance with these Terms, fraudulent
      activities, or repeated delivery failures.
    </p>

    <h4>
      <span>8.3</span> Effects of Termination
    </h4>
    <p>
      Upon termination, the Supplier will no longer have access to the MDS
      system. All pending deliveries must still be completed as per contractual
      agreements.
    </p>

    <h3>9. Limitation of Liability</h3>
    <p>
      The Administrator will not be liable for any indirect, incidental, or
      consequential damages resulting from the use or inability to use the MDS
      system. Suppliers agree that their sole remedy for any issues with the
      System is to discontinue its use.
    </p>

    <h3>10. Amendments to Terms</h3>
    <p>
      The Administrator reserves the right to modify these Terms and Conditions
      at any time. Continued use of the MDS system after such modifications
      constitutes acceptance of the revised Terms.
    </p>

    <h3>11. Acceptance of Terms</h3>
    <p>
      By registering for and using the MDS system, Suppliers confirm that they
      have read, understood, and agree to be bound by these Terms and
      Conditions.
    </p>
  </>
);

const TERMS_AZ = (
  <>
    <h3>1. Preambula</h3>
    <p>
      Bu qaydalar və şərtlər (bundan sonra “Şərtlər”) təchizatçıların /
      satıcıların (bundan sonra “Təchizatçı” və ya “Satıcı”) Əsas çatdırılma
      qrafiki (MDS) sistemində qeydiyyatını və sistemdən istifadəsini
      tənzimləyir. MDS sistemində qeydiyyatdan keçməklə və ya sistemdən istifadə
      etməklə, siz bu Şərtləri tam şəkildə qəbul edirsiniz. Əgər siz bu
      Şərtlərlə razı deyilsinizsə, o zaman sistemdən istifadə etmək hüququnuz
      yoxdur.
    </p>

    <h3>2. Anlayışlar</h3>
    <p>
      MDS sistemi: Çatdırılma qrafiklərinin idarə olunması və
      optimallaşdırılması üçün istifadə olunan Əsas çatdırılma qrafiki sistemi.
    </p>
    <p>
      Təchizatçı/Satıcı: MDS sistemindən istifadə üçün qeydiyyatdan keçən və
      mal, material və ya digər xidmətləri təmin edən hər hansı hüquqi və ya
      fiziki şəxs.
    </p>

    <h3>3. Qeydiyyat prosesi</h3>
    <h4>
      <span>3.1</span> Uyğunluq
    </h4>
    <p>
      Təchizatçılar MDS sistemində qeydiyyatdan keçmək və sistemdən istifadə
      etmək üçün Administrator tərəfindən əvvəlcədən müəyyən edilmiş uyğunluq
      meyarlarına cavab verməlidirlər. Uyğunluq tələblərinə cavab verilməzsə,
      Təchizatçıların sistemə daxil olmalarına qadağa qoyula bilər.
    </p>

    <h4>
      <span>3.2</span> Dəqiq məlumatların verilməsi
    </h4>
    <p>
      Təchizatçılar qeydiyyat zamanı şirkətin rekvizitləri, əlaqə məlumatlarını,
      sürücülər (əgər varsa, sərnişinlər) və müvafiq çatdırılma imkanları ilə
      bağlı dəqiq və aktual məlumat təqdim etməlidirlər. Bu məlumatları təqdim
      etməzdən əvvəl, sürücülərin (əgər varsa, sərnişinlərin) razılığı
      alınmalıdır. Təchizatçılar zəruri hallarda bu məlumatları
      yeniləməlidirlər.
    </p>

    <h4>
      <span>3.3</span> Qeydiyyatın təsdiq olunması
    </h4>
    <p>
      Təqdim edilən məlumatların düzgünlüyü yoxlandıqdan sonra qeydiyyat
      müraciətləri sistem tərəfindən təsdiqlənir. Yanlış və ya natamam
      məlumatların verilməsi qeydiyyat müraciətlərinin sistem tərəfindən rədd
      edilməsi ilə nəticələnəcək.
    </p>

    <h3>4. Təchizatçının vəzifələri</h3>
    <h4>
      <span>4.1</span> Çatdırılma qrafikinə riayət
    </h4>
    <p>
      Təchizatçılar razılaşırlar ki, MDS sistemində əks olunmuş bütün
      qrafiklərə, eləcə də çatdırılma müddətləri və həcmlərinə riayət edəcəklər.
    </p>

    <h4>
      <span>4.2</span> Sistemdən istifadə
    </h4>
    <p>
      Təchizatçılar razılaşırlar ki, MDS sistemindən yalnız müqavilə öhdəlikləri
      çərçivəsində çatdırılmaları idarə və koordinasiya etmək üçün istifadə
      edəcəklər. Sistemdən sui-istifadə və ya yanlış məlumatların daxil edilməsi
      qəti qadağandır.
    </p>

    <h4>
      <span>4.3</span> Verilənlərin dəqiqliyi
    </h4>
    <p>
      Təchizatçılar MDS sisteminə daxil edilən bütün verilənlərin, o cümlədən
      çatdırılma vaxtları/məntəqələri və sürücü/avtomobil ilə bağlı məlumatların
      dəqiq və aktual olmasını təmin etməlidirlər.
    </p>

    <h4>
      <span>4.4</span> Konfidensiallıq
    </h4>
    <p>
      Təchizatçılar MDS sistemindən əldə edilən bütün həssas məlumatların
      konfidensiallığını qorumalıdırlar. Konfidensial məlumatları icazəsiz
      olaraq üçüncü şəxslərlə paylaşmaq qəti qadağandır.
    </p>

    <h3>5. Çatdırılma və icra standartları</h3>
    <h4>
      <span>5.1</span> Razılaşdırılmış Şərtlərə riayət edilməsi
    </h4>
    <p>
      Təchizatçılar bütün çatdırılmaların müqavilədə razılaşdırılmış
      spesifikasiya, müddət və standartlara cavab verməsini təmin etməlidirlər.
      MDS sistemindən istifadə etməklə, FA nümayəndəsinə hər hansı gecikmə və ya
      kənaraçıxma barədə mümkün qədər tez məlumat verilməlidir.
    </p>

    <h4>
      <span>5.2</span> Fors-major
    </h4>
    <p>
      Təchizatçının iradəsindən kənar baş verən gözlənilməz hallar (məsələn,
      təbii fəlakət və ya tətil) çatdırılma qrafikinə riayət etməyə mane olarsa,
      Təchizatçılar dərhal <a href="mailto:mds@cop29.az">mds@cop29.az</a>{" "}
      elektron poçtu vasitəsilə MDS komandasına məlumat verməli və ya yeni
      çatdırılma şərtlərini razılaşmaq üçün{" "}
      <a href="tel:+994 10 252 44 80">+994 10 252 44 80</a> nömrəli telefonla
      əlaqə saxlamalıdırlar.
    </p>

    <h3>6. Sistemdən istifadə və təhlükəsizlik</h3>
    <h4>
      <span>6.1</span> Sistemə giriş məlumatları
    </h4>
    <p>
      Təchizatçılar sistemə daxil olmaq üçün istifadə etdikləri məlumatların
      konfidensiallığını təmin etməlidirlər. Sistemə istənilən icazəsiz giriş və
      ya istifadə halları barədə dərhal MDS komandasına məlumat verməlidir.
    </p>

    <h4>
      <span>6.2</span> Sistemin toxunulmazlığı
    </h4>
    <p>
      Təchizatçılar MDS sisteminin təhlükəsizliyi, toxunulmazlığı və ya icrasına
      xələl gətirə biləcək hər hansı fəaliyyətlə, o cümlədən, lakin bununla
      məhdudlaşmadan, hakerlik, sistemdəki proqram təminatı və ya sənədləri
      təhrif etmək/saxtalaşdırmaq məqsədilə müdaxilə və ya sistemə zərərli
      proqram təminatının (“malware”) gizli daxil edilməsi ilə məşğul
      olmamalıdırlar.
    </p>

    <h3>7. Verilənlərin qorunması və konfidensiallıq</h3>
    <h4>
      <span>7.1</span> Verilənlərin toplanması
    </h4>
    <p>
      Təchizatçılar MDS sistemindən istifadə etməklə razılaşırlar ki,
      Administrator sistem əməliyyatlarını təkmilləşdirmək üçün çatdırılma, icra
      göstəriciləri və təchizatçının fəaliyyətləri ilə bağlı verilənləri
      toplaya, saxlaya və istifadə edə bilər.
    </p>

    <h4>
      <span>7.2</span> Təchizatçı verilənlərinin qorunması
    </h4>
    <p>
      MDS komandası Təchizatçı verilənlərini qorumaq üçün müvafiq texniki və
      təşkilati tədbirlər həyata keçirəcək. Bununla belə, Təchizatçılar öz
      sistemlərini icazəsiz girişdən qorumaq üçün tədbir görməlidirlər.
    </p>

    <h3>8. Xitam və müvəqqəti dayandırma</h3>
    <h4>
      <span>8.1</span> Təchizatçı tərəfindən xitam
    </h4>
    <p>
      Təchizatçılar istənilən vaxt qeydiyyata xitam verərək MDS sistemindən
      istifadəni dayandıra bilərlər, bir şərtlə ki, yerinə yetirilməmiş bütün
      çatdırılma öhdəliklərini icra etmiş olsunlar.
    </p>

    <h4>
      <span>8.2</span> Administrator tərəfindən xitam
    </h4>
    <p>
      Administrator ən azı bu Şərtlərə riayət edilməməsi, saxtakarlıq və ya
      çatdırılmanın dəfələrlə uğursuz olması kimi səbəblərə görə (xəbərdarlıq
      edərək və ya xəbərdarlıq etmədən) Təchizatçının MDS sisteminə girişini
      istənilən vaxt müvəqqəti dayandırmaq və ya birdəfəlik ləğv etmək hüququna
      malikdir.
    </p>

    <h4>
      <span>8.3</span> Xitamın nəticələri
    </h4>
    <p>
      Xitam verildikdən sonra Təchizatçı artıq MDS sisteminə daxil ola
      bilməyəcək. Tamamlanmamış bütün çatdırılma prosesləri müqavilə
      çərçivəsində əldə olunan razılaşmalara uyğun qaydada tamamlanmalıdır.
    </p>

    <h3>9. Maddi məsuliyyətin məhdudlaşdırılması</h3>
    <p>
      Administrator MDS sistemindən istifadəyə görə hər hansı birbaşa, dolayısı
      ilə, təsadüfi və ya xüsusi ziyana görə (o cümlədən, lakin bununla
      məhdudlaşmadan, itirilmiş gəlirlər, məlumatların itirilməsi və ya
      istifadəsi) məsuliyyət daşımır.
    </p>

    <h3>10. Şərtlərdəki dəyişikliklər</h3>
    <p>
      Administrator bu Şərtləri istənilən vaxt dəyişdirə bilər. Dəyişikliklər
      dərhal qüvvəyə minir. Dəyişikliklər edildikdən sonra sistemə daxil olan
      Təchizatçılar avtomatik olaraq yeni Şərtləri qəbul etmiş hesab olunurlar.
    </p>

    <h3>11. İcra və hüquqi qüvvə</h3>
    <p>
      Bu Şərtlər Azərbaycan Respublikası qanunvericiliyinə uyğun olaraq icra
      ediləcək. Şərtlərin pozulması halları ilə bağlı mübahisələr, müvafiq
      qanunvericiliyə uyğun olaraq, tərəflər arasında razılaşdırılmış yerli
      məhkəmələrdə həll olunacaq.
    </p>

    <h3>12. Sifariş üzrə şərt və müddəalar:</h3>
    <p>
      <span class="number">12.1</span> Sürücülər və nəqliyyat vasitələri bütün
      təhlükəsizlik tələblərinə cavab verməlidir.
    </p>
    <p>
      <span class="number">12.2</span> MSA yoxlanışı tələb olunarsa, sürücülər
      MSA-ya ən azı 3 saat əvvəl gəlməlidirlər.
    </p>
    <p>
      <span class="number">12.3</span> MSA-ya gəliş vaxtları və qapıda həyata
      keçirilən əməliyyatlar MSA və məkan tərəfindən verilən qrafiklərə uyğun
      olmalıdır.
    </p>
    <p>
      <span class="number">12.4</span> Sürücülər MSA-ya gəldikdən və tədbir
      məkanına daxil olduqdan sonra daim nəqliyyat vasitələrinin yanında
      qalmalıdırlar.
    </p>
    <p>
      <span class="number">12.5</span> Sürücülər sahədə müşayiət üzrə bütün
      prosedurlara əməl etməli və səfər boyu maşından çıxmamalıdırlar.
    </p>
    <p>
      <span class="number">12.6</span> Bütün nəqliyyat vasitələri müvafiq sayt
      protokollarına uyğun olaraq yoxlanılacaq.
    </p>
    <p>
      <span class="number">12.7</span> Avtomobillərin icazəsiz girişi,
      təhlükəsizlik tələblərinə riayət edilməməsi və ya qeyri-dəqiq çatdırılma
      məlumatları tədbir məkanına girişin gecikməsinə və ya qadağan edilməsinə
      səbəb ola bilər.
    </p>
    <p>
      <span class="number">12.8</span> Avtomobilinizi daim səliqəli və təmiz
      saxlayın. Avtomobiliniz məkanın təhlükəsizliyi baxımından Təhlükəsizlik
      xidmətinin əməkdaşları tərəfindən yoxlanıla bilər.
    </p>
    <p>
      <span class="number">12.9</span> Sürücülər nəqliyyat orqanlarının bütün
      qaydalarına və məkana giriş üçün çatdırılma təlimatlarına riayət
      etməlidirlər.
    </p>
    <p>
      <span class="number">12.10</span> Məkan və ya MSA işçiləri tərəfindən
      tələb edildikdə, sifariş sənədini yoxlanılmaq üçün təqdim edin.
    </p>
    <p>
      <span class="number">12.11</span> Plomblama üçün avtomobilinizin xarici
      hissəsini təmiz saxlayın.
    </p>
  </>
);
